/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMedicalRecords = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 15h2v2h-2v2h-2v-2H9v-2h2v-2h2z" />
        <path
          clipRule="evenodd"
          d="M21 10h1v12H2V9h2V6h3V2h14zM4 20h16v-8H9.086l-1-1H4zM6 9h2.914l1 1H15V8H6zm3-3h8v4h2V4H9z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgMedicalRecords as MedicalRecords };
